import { HiXMark } from "react-icons/hi2";

export const CrossIcon = ({ width, height, color, ...props }) => (
  <HiXMark
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
